import { IApplicationState } from '../../types/redux';
import { ELoadingStatus } from '../../types/redux/loadingStatus';

export function selectComparisonLoading(state: IApplicationState): boolean {
  const statusList = Object.values(state.comparison.status);

  return statusList.some(status => status === ELoadingStatus.Loading);
}
